/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { extend } from '@thd-nucleus/data-sources';

// Define the HOC function
export const withContainer = (WrappedComponent, Container) => {
  const Wrapped = (props) => (
    <Container>
      <WrappedComponent {...props} />
    </Container>
  );

  Wrapped.dataModel = extend({}, WrappedComponent);

  return Wrapped;
};